import { List } from 'react-admin';

import { useTitle } from '@src/hooks/useTitle';
import {
  ApplyStatusStrip,
  FacetFilterSync,
  GuideAccordion,
  ResalePricingTabShell,
  RulesDatagrid,
  useRuleFilters,
} from '../shared';
import WithPricingGuard from './WithPricingGuard';
import PricingRulesActions from './PricingRulesActions';
import PricingRulesDocumentation from './PricingRulesDocumentation';

const PRICING_TYPE = 'yerdle_price' as const;

const PricingRulesList = () => {
  const { title } = useTitle('Resale Pricing · Price Rules');
  const filters = useRuleFilters(PRICING_TYPE);

  return (
    <ResalePricingTabShell tab="pricingRules">
      <WithPricingGuard>
        <List
          perPage={25}
          sort={{ field: 'position', order: 'ASC' }}
          title={title}
          filters={filters}
          actions={<PricingRulesActions pricingType={PRICING_TYPE} />}
          exporter={false}
        >
          <FacetFilterSync />
          <ApplyStatusStrip pricingType={PRICING_TYPE} />
          <RulesDatagrid pricingType={PRICING_TYPE} />
        </List>
        <GuideAccordion title="How price rules work">
          <PricingRulesDocumentation />
        </GuideAccordion>
      </WithPricingGuard>
    </ResalePricingTabShell>
  );
};

export default PricingRulesList;
